import { localeInitial } from './locale';
import { screenInitial } from './screen';
import { userInitial } from './user';
import type { GlobalContextReducerState } from './types';
import { toastInitial } from './toast';
import { caseHistoryInitial } from './case-history';
import { navbarStateInitial } from './navbarOpenState';
import { activeFeatureConfigInitial } from './activeFeatureConfig';
import { Portal } from '@dfg/brahma-types';
import { coBrandDetailsInitial } from './coBrandDetails';

export const defaultState: GlobalContextReducerState = {
  screen: screenInitial,
  locale: localeInitial,
  user: userInitial,
  toast: toastInitial,
  caseHistoryModal: caseHistoryInitial,
  navbarState: navbarStateInitial,
  activeFeatureConfig: activeFeatureConfigInitial,
  portal: Portal.OPS,
  coBrandDetails: coBrandDetailsInitial,
  isReportRegenerationModalOpen: false
};
